import { clearSlot, replaceSlot } from "../../features/slots/slotsSlice";
import * as React from 'react';
import { useState } from "react";
import { useDispatch } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import { useAppContext } from "../../hooks/AppContext";
import { markTaskComplete, snoozeTask, markChecklistItemComplete } from "../../services/GraphService/GraphService";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { BucketView } from "./BucketView";
import IconButton from "@mui/material/IconButton";
import { ProgressOverlay } from "../../components/ProgressOverlay";
import Checkbox from "@mui/material/Checkbox";
import { CategoryProcessor } from '../processors/CategoryProcessor';
import { TaskDetailView } from "./TaskDetailView";
import LaunchIcon from '@mui/icons-material/Launch';
import { Snackbar, Typography, useTheme } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { calculateMinutesSince } from "../../utils/DateTimeUtils";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TaskTitle from "./TaskTitle";
import { useSwipeable } from "react-swipeable";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PickTaskView from "./PickTaskView";
import { useLongPress } from "../../hooks/useLongPress";
import { playCompleteSound, playSnoozeSound } from "../../utils/SoundUtils";
const container = {
    display: "grid",
    gridTemplateColumns: "0.1fr 1fr 0.1fr",
    gridTemplateAreas: `
      'header header actions'
      'done title actions'
   `,
    width: '100%'
};
const header = {
    gridArea: 'header',
    fontSize: '0.7em',
    fontWeight: 'bold'
};
const done = {
    gridArea: 'done'
};
const actions = {
    textAlign: 'end',
    gridArea: 'actions',
};
const title = {
    gridArea: 'title',
    paddingTop: '5px'
};
export const SlotView = ({ slot, slots, index, updateCounter }) => {
    var _a, _b;
    const dispatch = useDispatch();
    const app = useAppContext();
    const theme = useTheme();
    const secondaryColor = theme.palette.text.secondary;
    const [bProgressOverlayOpen, setProgressOverlayOpen] = useState(false);
    const [bChecked, setChecked] = useState(false);
    const [bOpenDialog, setOpenDialog] = useState(false);
    const [bOpenSnack, setOpenSnack] = useState(false);
    const [snackTitle, setSnackTitle] = useState(''); // TODO use one snackbar in the parent component
    const [bOpenTaskList, setOpenTaskList] = useState(false);
    const [snoozeMenuAnchor, setSnoozeMenuAnchor] = React.useState(null);
    const [datePickerOpen, setDatePickerOpen] = React.useState(false);
    const [pickedDate, setPickedDate] = React.useState(null);
    const clickTimerRef = React.useRef(null);
    const snoozeButtonRef = React.useRef(null);
    const longPressHandlers = useLongPress(() => {
        setSnoozeMenuAnchor(snoozeButtonRef.current);
    });
    // Swipe-to-clear: the row follows the finger, revealing a "clear" backdrop underneath.
    const [dx, setDx] = useState(0);
    const [leaving, setLeaving] = useState(false);
    const wrapperRef = React.useRef(null);
    const leaveTimerRef = React.useRef(null);
    const reducedMotion = typeof window !== 'undefined' && !!window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const SLIDE_MS = reducedMotion ? 0 : 200;
    const getWidth = () => { var _a; return ((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 300; };
    const getThreshold = () => Math.max(120, getWidth() * 0.4);
    React.useEffect(() => () => {
        if (leaveTimerRef.current)
            clearTimeout(leaveTimerRef.current);
    }, []);
    const commitClear = () => {
        setLeaving(true);
        setDx(getWidth());
        leaveTimerRef.current = setTimeout(() => {
            leaveTimerRef.current = null;
            dispatch(clearSlot(index));
            updateCounter();
            setLeaving(false);
            setDx(0);
        }, SLIDE_MS);
    };
    const swipeHandlers = useSwipeable({
        onSwiping: (e) => {
            if (leaving)
                return;
            // only horizontal-right drags move the row; vertical scrolling is left alone
            if (e.dir === 'Right' || dx > 0)
                setDx(Math.max(0, e.deltaX));
        },
        onSwiped: (e) => {
            if (leaving)
                return;
            if (e.dir === 'Right' && e.deltaX > getThreshold()) {
                commitClear();
            }
            else {
                setDx(0);
            }
        },
        delta: 10,
        preventScrollOnSwipe: false,
        trackTouch: true,
        trackMouse: false
    });
    const isEmpty = slot.isEmpty();
    if (isEmpty) {
        return null;
    }
    if (bChecked === true && !slot.isComplete()) {
        setChecked(false);
    }
    const slotStyle = {
        display: "grid"
    };
    let backgroundColor = "#fff";
    if (index == 0) {
        slotStyle.borderLeft = "solid 2px #660066";
        backgroundColor = "rgb(102, 0, 102,0.25)";
    }
    if (index > 0 && index < 4) {
        slotStyle.borderLeft = "solid 2px #00cc44";
        backgroundColor = "rgb(0, 204, 68,0.25)";
    }
    if (index >= 4) {
        slotStyle.borderLeft = " solid 2px #996600";
        backgroundColor = "rgb(153, 102, 0,0.25)";
    }
    const toggleTask = async (e) => {
        e.stopPropagation();
        if (!bChecked) {
            playCompleteSound();
            try {
                setProgressOverlayOpen(true);
                setChecked(true);
                if (slot.isCheckListItem()) {
                    await markChecklistItemComplete(slot.getTaskId(), slot.getCheckListItemId(), app.authProvider);
                }
                else {
                    await markTaskComplete(slot, app.authProvider);
                }
                slot.status = "completed";
                dispatch(replaceSlot(slot.object()));
            }
            finally {
                setProgressOverlayOpen(false);
                updateCounter();
            }
        }
    };
    const snoozeSlot = async (e) => {
        e.stopPropagation();
        playSnoozeSound();
        slot.status = 'postponed';
        dispatch(replaceSlot(slot.object()));
        try {
            setProgressOverlayOpen(true);
            const daysToSnoozeBy = await CategoryProcessor.snoozeTask(app.authProvider, slot);
            const response = await snoozeTask(slot, daysToSnoozeBy, app.authProvider);
            setSnackTitle(`Postponed: ${response.title}`);
            setOpenSnack(true);
        }
        finally {
            setProgressOverlayOpen(false);
        }
    };
    const handleSnoozeClick = (e) => {
        e.stopPropagation();
        if (clickTimerRef.current) {
            clearTimeout(clickTimerRef.current);
            clickTimerRef.current = null;
            setSnoozeMenuAnchor(e.currentTarget);
        }
        else {
            clickTimerRef.current = setTimeout(() => {
                clickTimerRef.current = null;
                snoozeSlot(e);
            }, 250);
        }
    };
    const snoozeToOffset = async (offsetDays) => {
        playSnoozeSound();
        slot.status = 'postponed';
        dispatch(replaceSlot(slot.object()));
        setSnoozeMenuAnchor(null);
        try {
            setProgressOverlayOpen(true);
            const response = await snoozeTask(slot, offsetDays, app.authProvider);
            setSnackTitle(`Postponed: ${response.title}`);
            setOpenSnack(true);
        }
        finally {
            setProgressOverlayOpen(false);
        }
    };
    const handlePostponeToTomorrow = () => snoozeToOffset(1);
    const handlePostponeToNextMonday = () => {
        const offset = moment().add(1, 'week').startOf('isoWeek')
            .diff(moment().startOf('day'), 'days');
        snoozeToOffset(offset);
    };
    const handleOpenDatePicker = () => {
        setSnoozeMenuAnchor(null);
        setPickedDate(null);
        setDatePickerOpen(true);
    };
    const handleConfirmDate = () => {
        if (!pickedDate)
            return;
        const offset = pickedDate.diff(moment().startOf('day'), 'days');
        if (offset < 1)
            return;
        snoozeToOffset(offset);
        setDatePickerOpen(false);
    };
    const openDialog = () => {
        setOpenDialog(true);
    };
    const minutes = calculateMinutesSince(slot.added ? slot.added : "");
    const colorRed = Math.min(Math.floor(minutes / 5), 165);
    // blue -> red as the task ages; lighter shades so it stays readable in dark mode
    const color = theme.palette.mode === 'dark'
        ? `rgb(${90 + colorRed}, 90 ,${255 - colorRed})`
        : `rgb(${colorRed}, 0 ,${165 - colorRed})`;
    const formatMinutes = () => {
        if (minutes < 12 * 60) {
            return '';
        }
        let returnVal;
        const hours = Math.floor(minutes / 60);
        if (hours >= 24 * 7) {
            returnVal = 'week+';
        }
        else if (hours >= 24) {
            returnVal = 'day+';
        }
        else if (hours === 0) {
            returnVal = `${minutes} minute`;
            if (minutes > 1)
                returnVal += 's';
        }
        else {
            const remainder = minutes % 60;
            returnVal = `${hours} hours and ${remainder} minutes`;
        }
        return returnVal;
    };
    let slotHeader = React.createElement("span", null, slot.headerTitle);
    const handleSnackClose = (_, reason) => {
        if (reason == 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const switchTask = (index) => {
        setOpenTaskList(true);
    };
    const swipeProgress = Math.min(1, dx / getThreshold());
    const pastThreshold = !leaving && swipeProgress >= 1;
    const dragging = dx > 0 && !leaving;
    return (React.createElement(React.Fragment, null,
        React.createElement(Snackbar, { open: bOpenSnack, autoHideDuration: 6000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, message: snackTitle, onClose: handleSnackClose }),
        React.createElement(ProgressOverlay, { open: bProgressOverlayOpen }),
        !isEmpty &&
            React.createElement("div", { ref: wrapperRef, style: { position: 'relative', overflow: 'hidden', width: '100%' } },
                React.createElement("div", { "aria-hidden": true, style: {
                        position: 'absolute', top: 0, bottom: 0, left: 0, width: dx,
                        overflow: 'hidden', whiteSpace: 'nowrap',
                        display: 'flex', alignItems: 'center',
                        paddingLeft: 16, gap: 8, color: '#fff',
                        background: `rgba(211, 47, 47, ${0.25 + 0.75 * swipeProgress})`,
                        visibility: dx > 0 ? 'visible' : 'hidden',
                        transition: dragging ? 'none' : `width ${SLIDE_MS}ms ease-out`
                    } },
                    React.createElement(ClearIcon, { style: {
                            flexShrink: 0,
                            opacity: swipeProgress,
                            transform: `scale(${pastThreshold ? 1.3 : 0.6 + 0.4 * swipeProgress})`,
                            transition: reducedMotion ? 'none' : 'transform 0.15s ease-out'
                        } }),
                    React.createElement(Typography, { variant: "body2", style: { opacity: swipeProgress, fontWeight: 'bold' } }, pastThreshold ? 'Release to clear' : 'Clear')),
                React.createElement("div", Object.assign({}, swipeHandlers, { style: Object.assign(Object.assign({}, container), { position: 'relative', transform: `translateX(${dx}px)`, opacity: leaving ? 0 : 1, transition: dragging ? 'none' : `transform ${SLIDE_MS}ms ease-out, opacity ${SLIDE_MS}ms ease-out` }) }),
                    React.createElement("div", { style: header }, slotHeader),
                    React.createElement("div", { style: done },
                        React.createElement(Checkbox, { onClick: toggleTask, checked: slot.isComplete() || bChecked })),
                    React.createElement("div", { style: title },
                        React.createElement("div", { className: slot.status, onClick: () => { switchTask(slot.getIndex()); } },
                            React.createElement(TaskTitle, { title: slot.title ? slot.title : "" })),
                        (slot.dueDate || ((_a = slot.tid) === null || _a === void 0 ? void 0 : _a.listName) === 'flaggedEmails' || slot.recurring) && (React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 4 } },
                            ((_b = slot.tid) === null || _b === void 0 ? void 0 : _b.listName) === 'flaggedEmails' && (React.createElement(MailOutlineIcon, { style: { fontSize: '0.85em', color: secondaryColor } })),
                            slot.recurring && (React.createElement(AutorenewIcon, { style: { fontSize: '0.85em', color: secondaryColor } })),
                            slot.dueDate && (React.createElement(Typography, { variant: "caption", display: "block", style: { fontSize: '0.75em', color: secondaryColor } }, slot.dueDate)))),
                        React.createElement(Typography, { variant: "body2", gutterBottom: true, style: { color: color } }, formatMinutes())),
                    React.createElement("div", { style: Object.assign(Object.assign({}, actions), { color: secondaryColor }) },
                        React.createElement(IconButton, { onClick: () => {
                                dispatch(clearSlot(index));
                                updateCounter();
                            } },
                            React.createElement(ClearIcon, null)),
                        React.createElement(IconButton, Object.assign({ ref: snoozeButtonRef, onClick: handleSnoozeClick }, longPressHandlers),
                            React.createElement(ArrowForwardIcon, null)),
                        React.createElement(PunchOutDetails, { slot: slot, openDialog: openDialog }),
                        React.createElement(IconButton, null,
                            React.createElement(BucketView, { slot: slot }))))),
        bOpenDialog && React.createElement(TaskDetailView, { open: bOpenDialog, closeDetailDialog: () => { setOpenDialog(false); }, slot: slot }),
        bOpenTaskList && React.createElement(PickTaskView, { slot: slot, open: true, onClose: () => { setOpenTaskList(false); }, slots: slots }),
        React.createElement(Menu, { open: Boolean(snoozeMenuAnchor), anchorEl: snoozeMenuAnchor, onClose: () => setSnoozeMenuAnchor(null) },
            React.createElement(MenuItem, { onClick: handlePostponeToTomorrow }, "Tomorrow"),
            React.createElement(MenuItem, { onClick: handlePostponeToNextMonday }, "Next Monday"),
            React.createElement(MenuItem, { onClick: handleOpenDatePicker }, "Pick a date\u2026")),
        React.createElement(Dialog, { open: datePickerOpen, onClose: () => setDatePickerOpen(false) },
            React.createElement(DialogTitle, null, "Pick a date"),
            React.createElement(DialogContent, null,
                React.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
                    React.createElement(DateCalendar, { value: pickedDate, onChange: (date) => setPickedDate(date), disablePast: true }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setDatePickerOpen(false) }, "Cancel"),
                React.createElement(Button, { onClick: handleConfirmDate, variant: "contained", disabled: !pickedDate }, "Confirm")))));
};
function PunchOutDetails({ slot, openDialog }) {
    return React.createElement(IconButton, { onClick: openDialog },
        React.createElement(LaunchIcon, null));
}
